export default {
  statusCode: {
    notLogin: 999,
    tokenError: 997,
  },
  // 重置后的初始密码
  resetPsdValue: '123456'
}